import styled from 'styled-components';

const StyledMenuBar = styled.div`
  height: 40px;
  display: flex;
  padding: 5px;
`;

export { StyledMenuBar };